import { render } from "./CookiesDropDown.vue?vue&type=template&id=00a00c3a&scoped=true&ts=true"
import script from "./CookiesDropDown.vue?vue&type=script&lang=ts"
export * from "./CookiesDropDown.vue?vue&type=script&lang=ts"

import "./CookiesDropDown.vue?vue&type=style&index=0&id=00a00c3a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\khale\\Cookies BIS\\Core\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00a00c3a"]])

export default __exports__